import overridesPl from "../i18n/taskTypeOverrides.pl.json";

const TOKEN_MAP = {
  a: "A",
  abs: "warto\u015b\u0107 bezwzgl\u0119dna",
  absolute: "warto\u015b\u0107 bezwzgl\u0119dna",
  add: "dodawanie",
  adjacent: "s\u0105siednie",
  all: "wszystkie",
  analysis: "analiza",
  and: "i",
  angle: "k\u0105t",
  area: "pole",
  arithmetic: "arytmetyczna",
  at: "co najmniej",
  average: "\u015brednia",
  axis: "o\u015b",
  bar: "s\u0142upkowy",
  base: "podstawa",
  basic: "podstawowe",
  between: "mi\u0119dzy",
  binomials: "dwumiany",
  books: "ksi\u0105\u017cki",
  bracket: "nawias",
  by: "przez",
  canonical: "kanoniczna",
  cards: "karty",
  cases: "przypadki",
  chart: "wykres",
  cinema: "kino",
  circle: "okr\u0105g",
  closed: "zamkni\u0119te",
  code: "kod",
  coef: "wsp\u00f3\u0142czynnik",
  coefficient: "wsp\u00f3\u0142czynnik",
  coefficients: "wsp\u00f3\u0142czynniki",
  coin: "moneta",
  combination: "kombinacje",
  common: "wsp\u00f3lny",
  compare: "por\u00f3wnanie",
  compute: "oblicz",
  convert: "zamiana",
  coordinate: "wsp\u00f3\u0142rz\u0119dna",
  count: "liczba",
  counts: "liczebno\u015b\u0107",
  cubic: "sze\u015bcienne",
  cube: "sze\u015bcian",
  cuboid: "prostopad\u0142o\u015bcian",
  decimal: "dziesi\u0119tny",
  denominator: "mianownik",
  determinant: "wyznacznik",
  diary: "dziennik",
  dice: "kostki",
  diff: "r\u00f3\u017cnica",
  difference: "r\u00f3\u017cnica",
  digit: "cyfra",
  dimension: "wymiar",
  distance: "odleg\u0142o\u015b\u0107",
  divisible: "podzielne",
  divide: "dzielenie",
  division: "dzielenie",
  domain: "dziedzina",
  double: "podw\u00f3jne",
  draws: "losowania",
  edge: "kraw\u0119d\u017a",
  elements: "elementy",
  equation: "r\u00f3wnanie",
  exclusion: "wy\u0142\u0105cze\u0144",
  exponential: "wyk\u0142adnicza",
  expression: "wyra\u017cenie",
  extreme: "ekstremum",
  factored: "iloczynowa",
  factor: "rozk\u0142ad",
  family: "rodzina",
  find: "znajd\u017a",
  for: "dla",
  fraction: "u\u0142amek",
  from: "z",
  function: "funkcja",
  general: "og\u00f3lna",
  geometric: "geometryczna",
  geo: "geometryczne",
  graph: "wykres",
  greater: "wi\u0119ksza",
  h00: "H00",
  height: "wysoko\u015b\u0107",
  identity: "to\u017csamo\u015b\u0107",
  inequality: "nier\u00f3wno\u015b\u0107",
  inclusion: "w\u0142\u0105cze\u0144",
  int: "ca\u0142kowita",
  integer: "liczba ca\u0142kowita",
  intercept: "przeci\u0119cie",
  interactive: "interaktywny",
  intervals: "przedzia\u0142y",
  intersection: "przeci\u0119cie",
  inverse: "odwrotne",
  k: "k",
  lateral: "boczna",
  length: "d\u0142ugo\u015b\u0107",
  line: "prosta",
  linear: "liniowe",
  list: "lista",
  log: "logarytm",
  logarithm: "logarytm",
  lottery: "loteria",
  matrix: "macierz",
  matura: "Matura",
  mean: "\u015brednia",
  median: "mediana",
  minus: "minus",
  mix: "mieszane",
  mixed: "mieszane",
  mode: "dominanta",
  modulo: "modulo",
  modern: "nowoczesna",
  multiply: "mno\u017cenie",
  nested: "z\u0142o\u017cone",
  no: "nie",
  nth: "n-ty",
  nwd: "NWD",
  nww: "NWW",
  number: "liczby",
  numbers: "liczby",
  of: "z",
  once: "jedna",
  open: "otwarte",
  operations: "dzia\u0142ania",
  ops: "dzia\u0142ania",
  pair: "para",
  parallel: "r\u00f3wnoleg\u0142a",
  parity: "parzysto\u015b\u0107",
  part: "cz\u0119\u015b\u0107",
  party: "partia",
  paint: "zamaluj",
  percent: "procent",
  perpendicular: "prostopad\u0142a",
  permutation: "permutacja",
  plus: "plus",
  plot: "wykre\u015bl",
  point: "punkt",
  points: "punkty",
  polynomial: "wielomian",
  position: "po\u0142o\u017cenie",
  power: "pot\u0119ga",
  powers: "pot\u0119gi",
  preserve: "zachowaj",
  prism: "graniastos\u0142up",
  probability: "prawdopodobie\u0144stwo",
  product: "iloczyn",
  products: "iloczyny",
  proportion: "proporcja",
  quadratic: "kwadratowe",
  quotient: "iloraz",
  race: "wy\u015bcig",
  radius: "promie\u0144",
  range: "zbi\u00f3r warto\u015bci",
  ratio: "stosunek",
  raw: "surowe",
  reach: "zasi\u0119g",
  rearranged: "po przekszta\u0142ceniu",
  rectangle: "prostok\u0105t",
  recursion: "rekurencja",
  recursive: "rekurencyjny",
  reduce: "redukuj",
  regular: "regularny",
  repetition: "powt\u00f3rzeniami",
  reverse: "odwrotne",
  roll: "rzut",
  root: "pierwiastek",
  roots: "pierwiastki",
  scientific: "naukowy",
  sequence: "ci\u0105g",
  set: "zbi\u00f3r",
  sets: "zbiory",
  shift: "przesuni\u0119cie",
  sides: "strony",
  sign: "znak",
  simplify: "uproszczanie",
  sin: "sinus",
  single: "pojedyncze",
  slope: "wsp\u00f3\u0142czynnik kierunkowy",
  solid: "bry\u0142",
  solutions: "rozwi\u0105zania",
  special: "szczeg\u00f3lne",
  squares: "kwadraty",
  sqrt: "pierwiastek",
  square: "kwadrat",
  stat: "statystyka",
  stats: "statystyka",
  std: "odchylenie standardowe",
  subtract: "odejmowanie",
  sum: "suma",
  surface: "powierzchnia",
  system: "uk\u0142ad",
  table: "tabela",
  tan: "tangens",
  tangent: "styczna",
  team: "zesp\u00f3\u0142",
  term: "wyraz",
  text: "tekstowe",
  through: "przez",
  times: "razy",
  tosses: "rzuty",
  total: "ca\u0142kowita",
  transform: "przekszta\u0142cenie",
  triangular: "tr\u00f3jk\u0105tny",
  triangle: "tr\u00f3jk\u0105t",
  trig: "trygonometria",
  triplet: "tr\u00f3jka",
  two: "dwa",
  unknown: "niewiadoma",
  unified: "jednolite",
  union: "suma",
  urn: "urna",
  value: "warto\u015b\u0107",
  variation: "wariacja",
  vector: "wektor",
  venn: "venna",
  viral: "wiralowy",
  volume: "obj\u0119to\u015b\u0107",
  what: "jaka",
  whole: "ca\u0142o\u015b\u0107",
  weighted: "wa\u017cona",
  with: "z",
  without: "bez",
  x: "x",
  y: "y",
  yes: "tak",
  zero: "zero",
};

const SUSPICIOUS_OVERRIDE_RE =
  /[?]|\b(Open|Closed|Find|Through|Point|Points|Sign|Parallel|Perpendicular|Squares|Roots|Cubic|Extreme|Sides|From|To|By|With|Without|Mean|Raw|Weighted|Diary|Code|Modern|Party|Roll|Draws|Single|Double|Reverse|Family|Mixed|Count|Elements|General|Canonical|Factored|Surface|Volume|Prism|Cylinder|Dice|Coin|Lottery|Urn|Race|Books|Paint|Chart|Scale|Length|Area|Numbers|What|Whole|Bracket|Plus|Minus|Compute|Convert|Domain|Derivative|Tangent|Graph|Plot|Shift|Ops)\b/i;

function isOverrideSuspicious(value) {
  const text = String(value || "").trim();
  if (!text) return true;
  return SUSPICIOUS_OVERRIDE_RE.test(text);
}

const PHRASE_REPLACEMENTS = [
  [/\bprocent z liczby\b/gi, "procent liczby"],
  [/\bu\u0142amek wsp\u00f3lny mianownik\b/gi, "u\u0142amek - wsp\u00f3lny mianownik"],
  [/\bu\u0142amek mieszane wsp\u00f3lny mianownik\b/gi, "u\u0142amek mieszany - wsp\u00f3lny mianownik"],
  [/\bu\u0142amek mno\u017cenie nawias plus minus\b/gi, "u\u0142amek - mno\u017cenie przez nawias (plus/minus)"],
  [/\bpierwiastek suma kwadrat\b/gi, "pierwiastek - suma (kwadrat)"],
  [/\bpierwiastek suma sze\u015bcian\b/gi, "pierwiastek - suma (sze\u015bcian)"],
  [/\bpodstawowe liczba ca\u0142kowita dzia\u0142ania\b/gi, "dzia\u0142ania na liczbach ca\u0142kowitych"],
  [/\bliniowe nier\u00f3wno\u015b\u0107\b/gi, "nier\u00f3wno\u015b\u0107 liniowa"],
  [/\bnier\u00f3wno\u015b\u0107 liniowe\b/gi, "nier\u00f3wno\u015b\u0107 liniowa"],
  [/\bkwadratowe nier\u00f3wno\u015b\u0107\b/gi, "nier\u00f3wno\u015b\u0107 kwadratowa"],
  [/\br\u00f3\u017cnica kwadraty\b/gi, "r\u00f3\u017cnica kwadrat\u00f3w"],
  [/\bsuma kwadraty\b/gi, "suma kwadrat\u00f3w"],
  [/\bsuma sze\u015bcian\b/gi, "suma sze\u015bcian\u00f3w"],
  [/\bsign z prosta\b/gi, "znak z prostej"],
  [/\bfind y intercept\b/gi, "znajd\u017a wyraz wolny"],
  [/\bthrough punkt\b/gi, "przez punkt"],
  [/\bparallel prosta\b/gi, "prosta r\u00f3wnoleg\u0142a"],
  [/\bperpendicular prosta\b/gi, "prosta prostopad\u0142a"],
  [/\bdwa kostki\b/gi, "dwie kostki"],
  [/\bdwa liczby\b/gi, "dwie liczby"],
  [/\bobj\u0119to\u015b\u0107 z cylinder\b/gi, "obj\u0119to\u015b\u0107 walca"],
  [/\btotal surface pole z cylinder\b/gi, "pole powierzchni ca\u0142kowitej walca"],
  [/\blateral surface pole z cylinder\b/gi, "pole powierzchni bocznej walca"],
  [/\s+/g, " "],
];

function splitTypeToTokens(type) {
  const raw = String(type || "").trim().replace(/Task$/i, "");
  const spaced = raw
    .replace(/_/g, " ")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
    .trim();
  if (!spaced) return [];
  return spaced.split(/\s+/).map((token) => token.trim()).filter(Boolean);
}

function prettifyTaskType(type, fallbackIndex = 0) {
  const raw = String(type || "").trim();
  if (!raw) return `Zadanie ${fallbackIndex + 1}`;
  const withoutSuffix = raw.replace(/Task$/i, "");
  const spaced = withoutSuffix.replace(/([a-z0-9])([A-Z])/g, "$1 $2");
  return spaced || `Zadanie ${fallbackIndex + 1}`;
}

function normalizeAutoLabel(label) {
  let next = String(label || "").trim();
  if (!next) return "";
  for (const [pattern, replacement] of PHRASE_REPLACEMENTS) {
    next = next.replace(pattern, replacement);
  }
  return next.trim();
}

function capitalizeLabel(label) {
  const value = String(label || "").trim();
  if (!value) return "";
  return value.charAt(0).toUpperCase() + value.slice(1);
}

function autoTranslateType(type) {
  const tokens = splitTypeToTokens(type);
  if (!tokens.length) return "";
  const translated = tokens.map((token) => {
    const key = token.toLowerCase();
    return TOKEN_MAP[key] || token;
  });
  return normalizeAutoLabel(translated.join(" "));
}

export function formatTaskTypeLabel(type, fallbackIndex = 0) {
  const key = String(type || "").trim();
  if (!key) return `Zadanie ${fallbackIndex + 1}`;

  const override = overridesPl?.[key];
  if (typeof override === "string" && override.trim() && !isOverrideSuspicious(override)) {
    return capitalizeLabel(override);
  }

  const auto = autoTranslateType(key);
  if (auto) return capitalizeLabel(auto);

  return capitalizeLabel(prettifyTaskType(key, fallbackIndex));
}
